import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const MemberMaster = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [members, setMembers] = useState([]);
  const [shgList, setShgList] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const [changePassword, setChangePassword] = useState(false);

const [submitLoading, setSubmitLoading] = useState(false);

  const [filters, setFilters] = useState({ searchKey: "" });

  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const municipality_id = localStorage.getItem("muniId");

  const [formData, setFormData] = useState({
  shg_id: "",
  name: "",
  beneficiary_id: "",
  mobile: "",
  email: "",
  password: "",
  confirm_password: "",
});


  //  FETCH MEMBER LIST
  const fetchMembers = async (
  pageNo = 1,
  searchValue = filters.searchKey,
  perPageValue = perPage
) => {
  setLoading(true);
  try {
    const res = await axios.post(
      `${BASE_URL}/memberList`,
      {
        searchKey: searchValue,
        page: pageNo,
        per_page: perPageValue,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const list = Array.isArray(res.data.data) ? res.data.data : [];
    const total = Number(res.data.total_records || 0);

    setMembers(list);
    setPage(pageNo);
    setTotalRecords(total);
    setTotalPages(Math.ceil(total / perPageValue));
  } catch (error) {
    if (error.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
              localStorage.clear();

      navigate("/ulb/login");
    } else {
      Swal.fire("Alert!", "Failed to load members", "error");
    }
  } finally {
    setLoading(false);
  }
};


  const fetchSHG = async () => {
    const res = await axios.post(`${BASE_URL}/vendorsList`,
         {vendor_type_id: 3},
         { headers: { Authorization: `Bearer ${token}` }});
    setShgList(res.data.data || []);
  };


const getPageNumbers = () => {
  const pages = [];
  const maxPagesToShow = 5;

  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, start + maxPagesToShow - 1);

  if (end - start < maxPagesToShow - 1) {
    start = Math.max(1, end - maxPagesToShow + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
};

  useEffect(() => {
    fetchMembers();
    // fetchCLF();
    // fetchALF();
    fetchSHG();
  }, []);

  // ===========================
  // ✅ MODAL OPEN
  // ===========================
  const openAddModal = () => {
    setShowModal(true);
    setIsEdit(false);
    setChangePassword(true);
    setFormData({

      shg_id: "",
      name: "",
      beneficiary_id: "",
      mobile: "",
      email: "",
      password: "",
      confirm_password: ""
    });
  };

  const openEditModal = (data) => {
  setShowModal(true);
  setIsEdit(true);
   setChangePassword(false);
  setEditId(data.user_id);

  setFormData({
    shg_id: data.shg_id,
    name: data.name,
    beneficiary_id: data.beneficiary_id,
    mobile: data.mobile,
    email: data.email || "",
    password: "",
    confirm_password: "",
  });
};



  // SAVE MEMBER

//  const handleSave = async () => {
//   try {
//     // ✅ basic validation
//     if (
//       !formData.shg_id ||
//       !formData.name ||
//       !formData.mobile ||
//       !formData.beneficiary_id
//     ) {
//       return Swal.fire(
//         "Validation Failed!",
//         "Required fields are missing",
//         "warning"
//       );
//     }

//     if (!isEdit) {
//       if (!formData.password || !formData.confirm_password) {
//         return Swal.fire(
//           "Validation Failed!",
//           "Password and Confirm Password are required",
//           "warning"
//         );
//       }

//       if (formData.password !== formData.confirm_password) {
//         return Swal.fire(
//           "Validation Failed!",
//           "Passwords do not match",
//           "warning"
//         );
//       }
//     }

//     const payload = {
//       shg_id: formData.shg_id,
//       name: formData.name,
//       beneficiary_id: formData.beneficiary_id,
//       email: formData.email,
//       mobile: formData.mobile,
//     };

//     if (!isEdit) {
//       payload.password = formData.password;
//       payload.confirm_password = formData.confirm_password;
//     }

//     if (isEdit) {
//       payload.user_id = editId;

//       if (formData.password) {
//         payload.password = formData.password;
//         payload.confirm_password = formData.confirm_password;
//       }
//     }

//     await axios.post(`${BASE_URL}/memberAddEdit`, payload, {
//       headers: { Authorization: `Bearer ${token}` },
//     });

//     Swal.fire(
//       "Success!",
//       isEdit ? "Member updated successfully" : "Member added successfully",
//       "success"
//     );

//     fetchMembers(page, filters.searchKey, perPage);
//     setShowModal(false);
//   }
//   catch (error) {
//     const msg = error.response?.data?.message || "Something went wrong";

//   Swal.fire("Warning!", msg, "warning");

//   if (error.response?.status === 401) {
//     localStorage.clear();
//     navigate("/ulb/login");
//   }
//   }
// };

const handleSave = async () => {
  try {
    // ✅ basic validation
    if (
      !formData.shg_id ||
      !formData.name ||
      !formData.mobile ||
      !formData.beneficiary_id
    ) {
      return Swal.fire(
        "Validation Failed!",
        "Required fields are missing",
        "warning"
      );
    }

    if (!isEdit) {
      if (!formData.password || !formData.confirm_password) {
        return Swal.fire(
          "Validation Failed!",
          "Password and Confirm Password are required",
          "warning"
        );
      }

      if (formData.password !== formData.confirm_password) {
        return Swal.fire(
          "Validation Failed!",
          "Passwords do not match",
          "warning"
        );
      }
    }

    const payload = {
      shg_id: formData.shg_id,
      name: formData.name,
      beneficiary_id: formData.beneficiary_id,
      email: formData.email,
      mobile: formData.mobile,
    };

    if (!isEdit) {
      payload.password = formData.password;
      payload.confirm_password = formData.confirm_password;
    }

    if (isEdit) {
      payload.user_id = editId;

      if (formData.password) {
        payload.password = formData.password;
        payload.confirm_password = formData.confirm_password;
      }
    }

    // 🔥 START LOADER
    setSubmitLoading(true);

    await axios.post(`${BASE_URL}/memberAddEdit`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    Swal.fire(
      "Success!",
      isEdit ? "Member updated successfully" : "Member added successfully",
      "success"
    );

    fetchMembers(page, filters.searchKey, perPage);
    setShowModal(false);

  } catch (error) {
    const msg = error.response?.data?.message || "Something went wrong";

    Swal.fire("Warning!", msg, "warning");

    if (error.response?.status === 401) {
      localStorage.clear();
              localStorage.clear();

      navigate("/ulb/login");
    }
  } finally {
    // 🔥 STOP LOADER
    setSubmitLoading(false);
  }
};


useEffect(() => {
  fetchMembers(1, filters.searchKey, perPage);
}, [perPage]);


  const theadStyle =
                  {padding: "5px",
                  fontWeight: "600",
                  letterSpacing: "0.5px",
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#edf7fe",
                  height: "10px",
                  borderBottom: "1px solid black",
                  borderTop: "1px solid black",
                  textAlign: "center",}



  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔷 HEADER */}
      <Card className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}>
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter"></i> SHG Members
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  value={filters.searchKey}
                  onChange={(e) =>
                    setFilters({ ...filters, searchKey: e.target.value })
                  }
                  style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
                />
              </Form.Group>
            </Col>

              <Col md={3}>
                                      <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                <Form.Select
                 style={{
                                borderRadius: "10px",
                                border: "2px solid #1565C1",
                              }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);

                  }}

                >
                  <option value={10}>10 Per Page</option>
                              <option value={25}>25 Per Page</option>
                              <option value={50}>50 Per Page</option>
                              <option value={100}>100 Per Page</option>
                </Form.Select>
                </Form.Group>
              </Col>

            <Col md={4} className="d-flex gap-3 mt-3">
              <Button
                className="w-50 fw-semibold text-white"
                style={{ background: "#1565C1", borderRadius: "10px" }}
                onClick={() => fetchMembers(1, filters.searchKey)}
                >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>

              <Button
  className="w-50 fw-semibold text-white"
  style={{ background: "#E53935", borderRadius: "10px" }}
  onClick={() => {
    setFilters({ searchKey: "" });
    setPage(1);
    setPerPage(10);

  fetchMembers(1, "", 10);
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i>  Reset
</Button>


            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Button
        className="mb-3 px-4 text-white fw-semibold"
        onClick={openAddModal}
        style={{
          background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
          borderRadius: "10px",
        }}
      >
        <i className="fa-solid fa-circle-plus me-2"></i> Add SHG Member
      </Button>

      {loading && (
                <div className="loader-wrapper">
                    <div className="blue-spinner"></div>

                    <div className="loading-line">
                    <div className="loading-progress"></div>
                    </div>

                    <p className="loading-text">Loading, please wait...</p>
                </div>
            )}

      {/* ✅ TABLE */}
      {!loading && (
        <Card className="mb-4 border-0"
        style={{
          background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
          boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          overflow: "hidden",
        }}>
          <Table bordered hover responsive striped>
            <thead>
              <tr>
                <th style={theadStyle}>SL</th>

                <th style={theadStyle}>Name</th>

                <th style={theadStyle}>Beneficiary Id</th>
                <th style={theadStyle}>Mobile</th>
                <th style={theadStyle}>SHG Group</th>

                {/* <th style={theadStyle}>Email</th> */}
                <th style={theadStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {members.length > 0 ? (
                members.map((row, index) => (
                  <tr key={row.id}>
                     <td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>

                    <td className="text-center">{row.name}</td>
                    <td className="text-center">{row.beneficiary_id || "-"}</td>
                    <td className="text-center">{row.mobile}</td>
                    <td className="text-center">{row.shg_name}</td>
                    {/* <td className="text-center">{row.email || "-"}</td> */}


                    <td className="text-center">
                                                            <Button
                                                              size="sm"
                                                              className="me-2"
                                                              style={{
                                                                background: "#1565C1",
                                                                border: "none",
                                                                padding: "6px 10px",
                                                                boxShadow: "0 3px 8px rgba(21,101,193,0.3)",
                                                              }}
                                                              onMouseEnter={(e) =>
                                                                (e.currentTarget.style.background = "#0D47A1")
                                                              }
                                                              onMouseLeave={(e) =>
                                                                (e.currentTarget.style.background = "#1565C1")
                                                              }
                                                              onClick={() => openEditModal(row)}
                                                            >
                                                              <i className="fa-solid fa-pen text-white"></i>
                                                            </Button>

                                                            {/* DELETE */}
                                                            <Button
                                                              size="sm"
                                                              style={{
                                                                background: "linear-gradient(90deg, #E53935, #D32F2F)",
                                                                border: "none",
                                                                padding: "6px 10px",
                                                                boxShadow: "0 3px 8px rgba(229,57,53,0.4)",
                                                              }}
                                                              onMouseEnter={(e) =>
                                                                (e.currentTarget.style.background =
                                                                  "linear-gradient(90deg, #D32F2F, #B71C1C)")
                                                              }
                                                              onMouseLeave={(e) =>
                                                                (e.currentTarget.style.background =
                                                                  "linear-gradient(90deg, #E53935, #D32F2F)")
                                                              }
                                                                            onClick={() => Swal.fire("Information", "This facility will be available soon.", "info")}

                                                           >
                                                              <i className="fa-solid fa-trash-can text-white"></i>
                                                            </Button>
                                                          </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <nav>
                    <ul className="pagination shadow-sm">

                        {/* First */}
                        {/* First */}
<li className={`page-item ${page === 1 ? "disabled" : ""}`}>
  <button
    className="page-link"
    onClick={() => fetchMembers(1, filters.searchKey, perPage)}
  >
    «
  </button>
</li>

{/* Prev */}
<li className={`page-item ${page === 1 ? "disabled" : ""}`}>
  <button
    className="page-link"
    onClick={() =>
      fetchMembers(page - 1, filters.searchKey, perPage)
    }
  >
    ‹
  </button>
</li>

{/* Page Numbers */}
{getPageNumbers().map((p) => (
  <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
    <button
      className="page-link"
      onClick={() =>
        fetchMembers(p, filters.searchKey, perPage)
      }
    >
      {p}
    </button>
  </li>
))}

{/* Next */}
<li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
  <button
    className="page-link"
    onClick={() =>
      fetchMembers(page + 1, filters.searchKey, perPage)
    }
  >
    ›
  </button>
</li>

{/* Last */}
<li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
  <button
    className="page-link"
    onClick={() =>
      fetchMembers(totalPages, filters.searchKey, perPage)
    }
  >
    »
  </button>
</li>


                    </ul>
                    </nav>
                </div>
             )}
        </Card>
      )}

      {/* ✅ MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg"  backdrop="static"
  keyboard={false} >
        <Modal.Header closeButton style={{ background: "#3399ff", color: "white" }}>
          <Modal.Title>{isEdit ? "Edit SHG Member" : "Add SHG Member"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>


<Row>
    <Col md={6}>

    <Form.Group className="mb-2">

              <Form.Label>SHG <span className="text-danger">*</span></Form.Label>
          <Form.Select
            className="mb-3"
            value={formData.shg_id}
            onChange={(e) =>
              setFormData({ ...formData, shg_id: e.target.value })
            }
          >
            <option value="">Select SHG</option>
            {shgList.map((s) => (
              <option key={s.id} value={s.id}>
                {s.vendors_master_name}
              </option>
            ))}
          </Form.Select>
          </Form.Group>


    </Col>

    <Col md={6}>
    <Form.Group className="mb-2">

              <Form.Label>Name <span className="text-danger">*</span></Form.Label>
          <Form.Control
            className="mb-3"
            placeholder="Name"
            value={formData.name}
            onChange={(e) =>
              setFormData({ ...formData, name: e.target.value })
            }
          />
          </Form.Group>
    </Col>
</Row>


          <Row>
            <Col md={6}>
            <Form.Group className="mb-2">

              <Form.Label>Beneficiary Id <span className="text-danger">*</span></Form.Label>
          <Form.Control
            className="mb-3"
            placeholder="Beneficiary Id"
            value={formData.beneficiary_id}
            onChange={(e) =>
              setFormData({ ...formData, beneficiary_id: e.target.value })
            }
          />
          </Form.Group>


            </Col>
            {/* <Col md={6}>
            <Form.Group className="mb-2">

              <Form.Label>Email</Form.Label>
          <Form.Control
            className="mb-3"
            placeholder="Email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
          </Form.Group>
            </Col> */}

            <Col md={6}>
                    <Form.Group className="mb-2">

              <Form.Label>Mobile <span className="text-danger">*</span></Form.Label>
          <Form.Control
            className="mb-3"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={(e) =>
              setFormData({ ...formData, mobile: e.target.value })
            }
          />
          </Form.Group>
                </Col>
          </Row>

            <Row>

                <Col md={12}>
                  <Form.Group className="mb-2">

              <Form.Label>User ID (Auto Generate)<span className="text-danger">*</span></Form.Label>
          <Form.Control
            className="mb-3"
            placeholder="User Id"
            value={formData.mobile}
            onChange={(e) =>
              setFormData({ ...formData, mobile: e.target.value })
            }
            disabled
          />
          </Form.Group>
                </Col>
            </Row>

{isEdit && !changePassword && (
  <div className="d-flex justify-content-end mb-3">
    <Button
      size="sm"
      variant="warning"
      onClick={() => setChangePassword(true)}
    >
      Change Password
    </Button>
  </div>
)}


{(!isEdit || changePassword) && (
  <Row>
    {/* PASSWORD */}
    <Col md={6}>
      <Form.Group className="mb-2">
        <Form.Label>
          Password <span className="text-danger">*</span>
        </Form.Label>

        <div className="position-relative">
          <Form.Control
            className="mb-3 pe-5"
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
          />

          <span
            className="position-absolute"
            style={{
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
            onClick={() => setShowPassword(!showPassword)}
          >
            <i
              className={`fa-solid ${
                showPassword ? "fa-eye-slash" : "fa-eye"
              }`}
            ></i>
          </span>
        </div>
      </Form.Group>
    </Col>

    {/* CONFIRM PASSWORD */}
    <Col md={6}>
      <Form.Group className="mb-2">
        <Form.Label>
          Confirm Password <span className="text-danger">*</span>
        </Form.Label>

        <div className="position-relative">
          <Form.Control
            className="mb-3 pe-5"
            placeholder="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            value={formData.confirm_password || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                confirm_password: e.target.value,
              })
            }
          />

          <span
            className="position-absolute"
            style={{
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#555",
            }}
            onClick={() =>
              setShowConfirmPassword(!showConfirmPassword)
            }
          >
            <i
              className={`fa-solid ${
                showConfirmPassword ? "fa-eye-slash" : "fa-eye"
              }`}
            ></i>
          </span>
        </div>
      </Form.Group>
    </Col>
  </Row>
)}


        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button
  variant="success"
  onClick={handleSave}
  disabled={submitLoading}
>
  {submitLoading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      {isEdit ? "Updating..." : "Submitting..."}
    </>
  ) : (
    isEdit ? "Update" : "Submit"
  )}
</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MemberMaster;
